import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  lead,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-296" data-mp="3f2n6bvub0opy">
      {eyebrow && <p className={`text-sm font-bold uppercase tracking-wider ${dark ? 'text-gold-light' : 'text-brand-600'}`} data-id="element-297" data-mp="3jzdnkmhuhqcy">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[32px] font-bold leading-[1.12] sm:text-5xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-298" data-mp="bmpuzjkepaq1">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[17px] leading-relaxed sm:text-lg ${dark ? 'text-brand-100' : 'text-muted'}`} data-id="element-299" data-mp="1shg3yoatgac">{lead}</p>}
    </div>;
}